// ============================================================
// cf-icon-picker.js � Reusable Icon Picker Helper
// Load hanya pada halaman yang membutuhkan icon picker.
//
// Dependencies: cf-form-helpers.js (CF.formHelpers.escHtml)
//
// Provides CF.iconPicker with:
//   CF.iconPicker.open(inputId, opts)   � Open picker modal
//   CF.iconPicker.close()               � Close picker modal
//   CF.iconPicker.FA_ICONS              � Icon dataset (~200 icons)
//
// Usage:
//   CF.iconPicker.open('my-icon-input', {
//       onSelect: function(iconClass) { ... },  // optional callback
//       colorInputId: 'my-icon-color',           // optional: auto-update icon preview color
//       previewId: 'my-icon-preview'             // optional: auto-update preview element
//   });
//
// HTML structure (auto-injected on first open):
//   - Modal backdrop with search input and icon grid
//   - Clicking an icon selects it and closes the modal
//
// Icon Preview helpers:
//   CF.iconPicker.updatePreview(iconInputId, previewId, color)
//   CF.iconPicker.setupPreview(iconInputId, colorInputId, previewId)
// ============================================================

window.CF = window.CF || {};

CF.iconPicker = (function () {
    'use strict';

    // ????????????????????????????????????????????????????????
    // FA Icon Dataset (~200 common icons with keyword tags)
    // ????????????????????????????????????????????????????????
    var FA_ICONS = [
        { c: 'fa-solid fa-house',                t: 'home house dashboard main' },
        { c: 'fa-solid fa-gauge-high',           t: 'dashboard gauge speed meter' },
        { c: 'fa-solid fa-bars',                 t: 'menu bars hamburger navigation' },
        { c: 'fa-solid fa-sitemap',              t: 'sitemap tree hierarchy structure' },
        { c: 'fa-solid fa-compass',              t: 'compass navigation direction' },
        { c: 'fa-solid fa-map',                  t: 'map location navigation' },
        { c: 'fa-solid fa-arrow-right',          t: 'arrow right forward' },
        { c: 'fa-solid fa-arrow-left',           t: 'arrow left back' },
        { c: 'fa-solid fa-arrows-rotate',        t: 'arrows rotate refresh sync' },
        { c: 'fa-solid fa-right-from-bracket',   t: 'logout signout exit' },
        { c: 'fa-solid fa-right-to-bracket',     t: 'login signin enter' },
        { c: 'fa-solid fa-user',                 t: 'user person profile account' },
        { c: 'fa-solid fa-users',                t: 'users people group team' },
        { c: 'fa-solid fa-user-plus',            t: 'user add create new register' },
        { c: 'fa-solid fa-user-gear',            t: 'user setting config admin' },
        { c: 'fa-solid fa-user-shield',          t: 'user shield security admin protect' },
        { c: 'fa-solid fa-user-tie',             t: 'user tie business manager' },
        { c: 'fa-solid fa-user-tag',             t: 'user tag label role' },
        { c: 'fa-solid fa-id-card',              t: 'id card identity badge' },
        { c: 'fa-solid fa-address-book',         t: 'address book contact' },
        { c: 'fa-solid fa-shield-halved',        t: 'shield security protect guard' },
        { c: 'fa-solid fa-lock',                 t: 'lock security password' },
        { c: 'fa-solid fa-unlock',               t: 'unlock open security' },
        { c: 'fa-solid fa-key',                  t: 'key password access auth' },
        { c: 'fa-solid fa-fingerprint',          t: 'fingerprint biometric identity' },
        { c: 'fa-solid fa-file',                 t: 'file document' },
        { c: 'fa-solid fa-file-lines',           t: 'file text document content' },
        { c: 'fa-solid fa-file-pdf',             t: 'file pdf document' },
        { c: 'fa-solid fa-file-excel',           t: 'file excel spreadsheet' },
        { c: 'fa-solid fa-file-csv',             t: 'file csv data' },
        { c: 'fa-solid fa-file-import',          t: 'file import upload' },
        { c: 'fa-solid fa-file-export',          t: 'file export download' },
        { c: 'fa-solid fa-file-invoice',         t: 'file invoice bill receipt' },
        { c: 'fa-solid fa-folder',               t: 'folder directory' },
        { c: 'fa-solid fa-folder-open',          t: 'folder open directory' },
        { c: 'fa-solid fa-image',                t: 'image photo picture' },
        { c: 'fa-solid fa-video',                t: 'video camera media' },
        { c: 'fa-solid fa-music',                t: 'music audio sound' },
        { c: 'fa-solid fa-newspaper',            t: 'newspaper news article' },
        { c: 'fa-solid fa-book',                 t: 'book read documentation' },
        { c: 'fa-solid fa-book-open',            t: 'book open read documentation manual' },
        { c: 'fa-solid fa-clipboard',            t: 'clipboard copy paste' },
        { c: 'fa-solid fa-clipboard-list',       t: 'clipboard list checklist tasks' },
        { c: 'fa-solid fa-clipboard-check',      t: 'clipboard check done approve' },
        { c: 'fa-solid fa-envelope',             t: 'envelope email mail message' },
        { c: 'fa-solid fa-envelope-open',        t: 'envelope open email read' },
        { c: 'fa-solid fa-paper-plane',          t: 'paper plane send message' },
        { c: 'fa-solid fa-bell',                 t: 'bell notification alert' },
        { c: 'fa-solid fa-bell-slash',           t: 'bell mute notification silent' },
        { c: 'fa-solid fa-comment',              t: 'comment chat message' },
        { c: 'fa-solid fa-comments',             t: 'comments chat discussion' },
        { c: 'fa-solid fa-message',              t: 'message chat sms' },
        { c: 'fa-solid fa-phone',                t: 'phone call contact' },
        { c: 'fa-solid fa-headset',              t: 'headset support call center' },
        { c: 'fa-solid fa-cart-shopping',        t: 'cart shopping ecommerce buy' },
        { c: 'fa-solid fa-bag-shopping',         t: 'bag shopping purchase' },
        { c: 'fa-solid fa-basket-shopping',      t: 'basket shopping purchase' },
        { c: 'fa-solid fa-credit-card',          t: 'credit card payment finance' },
        { c: 'fa-solid fa-money-bill',           t: 'money bill cash payment finance' },
        { c: 'fa-solid fa-money-bill-wave',      t: 'money bill wave payment' },
        { c: 'fa-solid fa-coins',                t: 'coins money currency finance' },
        { c: 'fa-solid fa-wallet',               t: 'wallet money payment finance' },
        { c: 'fa-solid fa-receipt',              t: 'receipt invoice bill' },
        { c: 'fa-solid fa-tag',                  t: 'tag label price' },
        { c: 'fa-solid fa-tags',                 t: 'tags labels category' },
        { c: 'fa-solid fa-barcode',              t: 'barcode scan product' },
        { c: 'fa-solid fa-qrcode',              t: 'qr code scan' },
        { c: 'fa-solid fa-chart-bar',            t: 'chart bar graph report analytics' },
        { c: 'fa-solid fa-chart-line',           t: 'chart line graph trend analytics' },
        { c: 'fa-solid fa-chart-pie',            t: 'chart pie graph analytics' },
        { c: 'fa-solid fa-chart-area',           t: 'chart area graph analytics' },
        { c: 'fa-solid fa-chart-column',         t: 'chart column bar graph analytics' },
        { c: 'fa-solid fa-chart-simple',         t: 'chart simple bar analytics' },
        { c: 'fa-solid fa-table',                t: 'table data grid spreadsheet' },
        { c: 'fa-solid fa-table-columns',        t: 'table columns layout' },
        { c: 'fa-solid fa-table-list',           t: 'table list data' },
        { c: 'fa-solid fa-database',             t: 'database storage data server' },
        { c: 'fa-solid fa-server',               t: 'server hosting infrastructure' },
        { c: 'fa-solid fa-hard-drive',           t: 'hard drive storage disk' },
        { c: 'fa-solid fa-cloud',                t: 'cloud storage hosting' },
        { c: 'fa-solid fa-cloud-arrow-up',       t: 'cloud upload' },
        { c: 'fa-solid fa-cloud-arrow-down',     t: 'cloud download' },
        { c: 'fa-solid fa-plus',                 t: 'plus add create new' },
        { c: 'fa-solid fa-minus',                t: 'minus remove subtract' },
        { c: 'fa-solid fa-pen',                  t: 'pen edit write' },
        { c: 'fa-solid fa-pen-to-square',        t: 'pen edit square modify' },
        { c: 'fa-solid fa-pencil',               t: 'pencil edit write draw' },
        { c: 'fa-solid fa-trash',                t: 'trash delete remove' },
        { c: 'fa-solid fa-trash-can',            t: 'trash can delete remove' },
        { c: 'fa-solid fa-check',                t: 'check done approve tick' },
        { c: 'fa-solid fa-check-double',         t: 'check double verify' },
        { c: 'fa-solid fa-xmark',               t: 'x close cancel reject' },
        { c: 'fa-solid fa-ban',                  t: 'ban block forbidden' },
        { c: 'fa-solid fa-download',             t: 'download save export' },
        { c: 'fa-solid fa-upload',               t: 'upload import send' },
        { c: 'fa-solid fa-share',                t: 'share forward send' },
        { c: 'fa-solid fa-link',                 t: 'link url chain' },
        { c: 'fa-solid fa-copy',                 t: 'copy duplicate clone' },
        { c: 'fa-solid fa-scissors',             t: 'scissors cut' },
        { c: 'fa-solid fa-magnifying-glass',     t: 'search magnifying glass find' },
        { c: 'fa-solid fa-filter',               t: 'filter funnel sort' },
        { c: 'fa-solid fa-sort',                 t: 'sort order' },
        { c: 'fa-solid fa-rotate',               t: 'rotate refresh reload' },
        { c: 'fa-solid fa-circle',               t: 'circle dot shape' },
        { c: 'fa-solid fa-square',               t: 'square shape box' },
        { c: 'fa-solid fa-star',                 t: 'star favorite rating' },
        { c: 'fa-solid fa-heart',                t: 'heart love favorite' },
        { c: 'fa-solid fa-bookmark',             t: 'bookmark save favorite' },
        { c: 'fa-solid fa-flag',                 t: 'flag mark report' },
        { c: 'fa-solid fa-thumbs-up',            t: 'thumbs up like approve' },
        { c: 'fa-solid fa-thumbs-down',          t: 'thumbs down dislike reject' },
        { c: 'fa-solid fa-trophy',               t: 'trophy award prize' },
        { c: 'fa-solid fa-medal',                t: 'medal award badge' },
        { c: 'fa-solid fa-crown',                t: 'crown king premium' },
        { c: 'fa-solid fa-calendar',             t: 'calendar date schedule' },
        { c: 'fa-solid fa-calendar-days',        t: 'calendar days date schedule' },
        { c: 'fa-solid fa-calendar-check',       t: 'calendar check event done' },
        { c: 'fa-solid fa-clock',                t: 'clock time schedule' },
        { c: 'fa-solid fa-stopwatch',            t: 'stopwatch timer countdown' },
        { c: 'fa-solid fa-hourglass-half',       t: 'hourglass time waiting' },
        { c: 'fa-solid fa-globe',                t: 'globe world earth web' },
        { c: 'fa-solid fa-earth-americas',       t: 'earth globe world' },
        { c: 'fa-solid fa-location-dot',         t: 'location pin map marker' },
        { c: 'fa-solid fa-building',             t: 'building office company' },
        { c: 'fa-solid fa-building-columns',     t: 'building columns bank government' },
        { c: 'fa-solid fa-city',                 t: 'city buildings skyline' },
        { c: 'fa-solid fa-industry',             t: 'industry factory manufacturing' },
        { c: 'fa-solid fa-warehouse',            t: 'warehouse storage logistics' },
        { c: 'fa-solid fa-store',                t: 'store shop retail' },
        { c: 'fa-solid fa-truck',                t: 'truck delivery shipping logistics' },
        { c: 'fa-solid fa-truck-fast',           t: 'truck fast delivery express' },
        { c: 'fa-solid fa-box',                  t: 'box package product' },
        { c: 'fa-solid fa-boxes-stacked',        t: 'boxes stacked inventory warehouse' },
        { c: 'fa-solid fa-gear',                 t: 'gear setting config cog' },
        { c: 'fa-solid fa-gears',               t: 'gears settings config' },
        { c: 'fa-solid fa-sliders',              t: 'sliders settings control adjust' },
        { c: 'fa-solid fa-wrench',               t: 'wrench tool fix repair' },
        { c: 'fa-solid fa-screwdriver-wrench',   t: 'screwdriver wrench tools maintenance' },
        { c: 'fa-solid fa-hammer',               t: 'hammer tool build' },
        { c: 'fa-solid fa-toolbox',              t: 'toolbox tools maintenance' },
        { c: 'fa-solid fa-palette',              t: 'palette design art color' },
        { c: 'fa-solid fa-paint-roller',         t: 'paint roller design theme' },
        { c: 'fa-solid fa-brush',                t: 'brush paint design' },
        { c: 'fa-solid fa-swatchbook',           t: 'swatch book colors design theme' },
        { c: 'fa-solid fa-code',                 t: 'code programming developer' },
        { c: 'fa-solid fa-terminal',             t: 'terminal command console' },
        { c: 'fa-solid fa-bug',                  t: 'bug debug error' },
        { c: 'fa-solid fa-robot',                t: 'robot ai automation bot' },
        { c: 'fa-solid fa-microchip',            t: 'microchip cpu processor hardware' },
        { c: 'fa-solid fa-wifi',                 t: 'wifi wireless internet' },
        { c: 'fa-solid fa-network-wired',        t: 'network wired lan' },
        { c: 'fa-solid fa-plug',                 t: 'plug power connect integration' },
        { c: 'fa-solid fa-bolt',                 t: 'bolt lightning power energy' },
        { c: 'fa-solid fa-fire',                 t: 'fire hot trending flame' },
        { c: 'fa-solid fa-snowflake',            t: 'snowflake cold freeze' },
        { c: 'fa-solid fa-sun',                  t: 'sun bright light day' },
        { c: 'fa-solid fa-moon',                 t: 'moon night dark' },
        { c: 'fa-solid fa-eye',                  t: 'eye view see visible' },
        { c: 'fa-solid fa-eye-slash',            t: 'eye slash hidden invisible' },
        { c: 'fa-solid fa-print',                t: 'print printer paper' },
        { c: 'fa-solid fa-list',                 t: 'list items menu' },
        { c: 'fa-solid fa-list-check',           t: 'list check todo tasks' },
        { c: 'fa-solid fa-list-ol',              t: 'list ordered numbered' },
        { c: 'fa-solid fa-grip',                 t: 'grip grid tiles' },
        { c: 'fa-solid fa-layer-group',          t: 'layer group stack' },
        { c: 'fa-solid fa-object-group',         t: 'object group layout' },
        { c: 'fa-solid fa-cubes',                t: 'cubes blocks modules' },
        { c: 'fa-solid fa-cube',                 t: 'cube block module' },
        { c: 'fa-solid fa-puzzle-piece',         t: 'puzzle piece plugin module' },
        { c: 'fa-solid fa-circle-info',          t: 'info circle information' },
        { c: 'fa-solid fa-circle-question',      t: 'question circle help' },
        { c: 'fa-solid fa-circle-exclamation',   t: 'exclamation circle warning alert' },
        { c: 'fa-solid fa-triangle-exclamation', t: 'triangle exclamation warning danger' },
        { c: 'fa-solid fa-circle-check',         t: 'circle check success done' },
        { c: 'fa-solid fa-circle-xmark',         t: 'circle x close error' },
        { c: 'fa-solid fa-spinner',              t: 'spinner loading' },
        { c: 'fa-solid fa-circle-notch',         t: 'circle notch loading spinner' },
        { c: 'fa-solid fa-expand',               t: 'expand fullscreen maximize' },
        { c: 'fa-solid fa-compress',             t: 'compress minimize' },
        { c: 'fa-solid fa-up-right-from-square', t: 'external link open new window' },
        { c: 'fa-solid fa-ellipsis',             t: 'ellipsis dots more options' },
        { c: 'fa-solid fa-ellipsis-vertical',    t: 'ellipsis vertical dots kebab menu' },
        { c: 'fa-solid fa-grip-vertical',        t: 'grip vertical drag handle' },
        { c: 'fa-solid fa-angles-right',         t: 'angles right chevron forward' },
        { c: 'fa-solid fa-chevron-right',        t: 'chevron right arrow' },
        { c: 'fa-solid fa-chevron-down',         t: 'chevron down arrow expand' },
        { c: 'fa-solid fa-chevron-up',           t: 'chevron up arrow collapse' },
        { c: 'fa-solid fa-caret-down',           t: 'caret down dropdown' },
        { c: 'fa-solid fa-caret-right',          t: 'caret right' },
        { c: 'fa-solid fa-hospital',             t: 'hospital medical health' },
        { c: 'fa-solid fa-stethoscope',          t: 'stethoscope medical doctor health' },
        { c: 'fa-solid fa-pills',                t: 'pills medicine pharmacy' },
        { c: 'fa-solid fa-syringe',              t: 'syringe injection vaccine medical' },
        { c: 'fa-solid fa-graduation-cap',       t: 'graduation cap education school' },
        { c: 'fa-solid fa-school',               t: 'school education building' },
        { c: 'fa-solid fa-chalkboard-user',      t: 'chalkboard teacher education training' },
        { c: 'fa-solid fa-flask',                t: 'flask science lab experiment' },
        { c: 'fa-solid fa-atom',                 t: 'atom science physics' },
        { c: 'fa-solid fa-microscope',           t: 'microscope science lab research' },
        { c: 'fa-solid fa-scale-balanced',       t: 'scale balanced justice law legal' },
        { c: 'fa-solid fa-gavel',                t: 'gavel judge law legal court' },
        { c: 'fa-solid fa-handshake',            t: 'handshake deal partnership agreement' },
        { c: 'fa-solid fa-hand-holding-dollar',  t: 'hand holding dollar payment donate' },
        { c: 'fa-solid fa-people-group',         t: 'people group team department' },
        { c: 'fa-solid fa-people-arrows',        t: 'people arrows transfer exchange' },
        { c: 'fa-solid fa-signs-post',           t: 'signs post direction guide' },
        { c: 'fa-solid fa-road',                 t: 'road path route' },
        { c: 'fa-solid fa-timeline',             t: 'timeline history progress' },
        { c: 'fa-solid fa-diagram-project',      t: 'diagram project workflow process' },
        { c: 'fa-solid fa-clipboard-user',       t: 'clipboard user assignment' },
        { c: 'fa-solid fa-rectangle-list',       t: 'rectangle list form register' }
    ];

    // ????????????????????????????????????????????????????????
    // State
    // ????????????????????????????????????????????????????????
    var _targetInputId = null;
    var _currentOpts = null;
    var _injected = false;

    function normalizeIconClass(iconClass) {
        var cls = (iconClass || '').trim();
        if (!cls) return '';

        if (/\b(fa-solid|fa-regular|fa-brands|fa-light|fa-thin|fa-duotone|fas|far|fab)\b/.test(cls)) {
            return cls;
        }

        if (/^fa-[a-z0-9-]+$/i.test(cls)) {
            return 'fa-solid ' + cls;
        }

        return cls;
    }

    // ????????????????????????????????????????????????????????
    // Inject modal HTML (once)
    // ????????????????????????????????????????????????????????
    function _ensureInjected() {
        if (_injected) return;
        _injected = true;

        var html =
            '<div id="cf-icon-picker-backdrop" class="cf-modal-backdrop" style="display:none">' +
                '<div class="cf-modal cf-modal-sm">' +
                    '<div class="modal-header">' +
                        '<div class="modal-header-title"><i class="fa-solid fa-icons"></i> Select Icon</div>' +
                        '<button class="modal-close" onclick="CF.iconPicker.close()"><i class="fa-solid fa-xmark"></i></button>' +
                    '</div>' +
                    '<div class="modal-body" style="padding:12px">' +
                        '<input type="text" id="cf-icon-picker-search" class="form-input" ' +
                            'placeholder="Search icons... (e.g. user, chart, home)" style="margin-bottom:12px" />' +
                        '<div id="cf-icon-picker-grid" class="cf-icon-grid"></div>' +
                        '<p id="cf-icon-picker-empty" style="display:none;text-align:center;color:#94A3B8;font-size:12px;padding:24px 0">' +
                            'No icons found. Try a different keyword.' +
                        '</p>' +
                    '</div>' +
                '</div>' +
            '</div>';

        document.body.insertAdjacentHTML('beforeend', html);

        document.getElementById('cf-icon-picker-search').addEventListener('input', function () {
            _renderGrid(this.value.toLowerCase().trim());
        });

        document.getElementById('cf-icon-picker-backdrop').addEventListener('click', function (e) {
            if (e.target === this) close();
        });
    }

    // ????????????????????????????????????????????????????????
    // Render icon grid
    // ????????????????????????????????????????????????????????
    function _renderGrid(query) {
        var grid = document.getElementById('cf-icon-picker-grid');
        var empty = document.getElementById('cf-icon-picker-empty');
        var filtered = query ? FA_ICONS.filter(function (ic) { return ic.t.indexOf(query) >= 0; }) : FA_ICONS;

        if (filtered.length === 0) {
            grid.innerHTML = '';
            empty.style.display = '';
            return;
        }
        empty.style.display = 'none';

        var html = '';
        filtered.forEach(function (ic) {
            html += '<button type="button" class="cf-icon-grid-item" title="' + ic.c + '" data-icon="' + ic.c + '">' +
                    '<i class="' + ic.c + '"></i></button>';
        });
        grid.innerHTML = html;
    }

    // ????????????????????????????????????????????????????????
    // Event delegation for icon selection
    // ????????????????????????????????????????????????????????
    document.addEventListener('click', function (e) {
        var item = e.target.closest('.cf-icon-grid-item');
        if (!item) return;
        var cls = item.dataset.icon;
        if (cls) _selectIcon(cls);
    });

    function _selectIcon(cls) {
        var normalizedClass = normalizeIconClass(cls);

        if (_targetInputId) {
            var input = document.getElementById(_targetInputId);
            if (input) {
                input.value = normalizedClass;
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }

        if (_currentOpts) {
            if (_currentOpts.previewId) {
                var color = '';
                if (_currentOpts.colorInputId) {
                    var colorInput = document.getElementById(_currentOpts.colorInputId);
                    if (colorInput) color = colorInput.value;
                }
                updatePreview(_targetInputId, _currentOpts.previewId, color);
            }

            if (typeof _currentOpts.onSelect === 'function') {
                _currentOpts.onSelect(normalizedClass);
            }
        }

        close();
    }

    // ????????????????????????????????????????????????????????
    // Public API
    // ????????????????????????????????????????????????????????

    /**
     * Open the icon picker modal.
     * @param {string} inputId � ID of the text input to write the selected icon class
     * @param {object} [opts] � Options
     * @param {string} [opts.colorInputId] � ID of the color input (for preview color)
     * @param {string} [opts.previewId] � ID of the preview element
     * @param {function} [opts.onSelect] � Callback(iconClass) after selection
     */
    function open(inputId, opts) {
        _ensureInjected();
        _targetInputId = inputId;
        _currentOpts = opts || {};

        document.getElementById('cf-icon-picker-search').value = '';
        _renderGrid('');
        document.getElementById('cf-icon-picker-backdrop').style.display = '';
        document.body.style.overflow = 'hidden';
    }

    function close() {
        var backdrop = document.getElementById('cf-icon-picker-backdrop');
        if (backdrop) backdrop.style.display = 'none';
        document.body.style.overflow = '';
    }

    /**
     * Update icon preview element.
     * @param {string} iconInputId � ID of the icon input
     * @param {string} previewId � ID of the preview element
     * @param {string} [color] � Optional color value
     */
    function updatePreview(iconInputId, previewId, color) {
        var previewEl = document.getElementById(previewId);
        if (!previewEl) return;
        var iconInput = document.getElementById(iconInputId);
        var iconClass = iconInput ? normalizeIconClass(iconInput.value.trim()) : '';
        if (!iconClass) {
            previewEl.innerHTML = '';
            return;
        }
        var esc = CF.formHelpers.escHtml;
        var colorStyle = color ? 'color:' + esc(color) : '';
        previewEl.innerHTML = '<i class="' + esc(iconClass) + '" style="font-size:18px;' + colorStyle + '"></i>';
    }

    /**
     * Setup auto-sync between icon input, color input, and preview.
     * @param {string} iconInputId � ID of the icon text input
     * @param {string} colorInputId � ID of the color text input
     * @param {string} previewId � ID of the preview element
     */
    function setupPreview(iconInputId, colorInputId, previewId) {
        var iconInput = document.getElementById(iconInputId);
        var colorInput = document.getElementById(colorInputId);
        if (iconInput) {
            iconInput.addEventListener('input', function () {
                var color = colorInput ? colorInput.value : '';
                updatePreview(iconInputId, previewId, color);
            });
        }
        if (colorInput) {
            colorInput.addEventListener('input', function () {
                updatePreview(iconInputId, previewId, this.value);
            });
        }
    }

    return {
        FA_ICONS:           FA_ICONS,
        open:               open,
        close:              close,
        normalizeIconClass: normalizeIconClass,
        updatePreview:      updatePreview,
        setupPreview:       setupPreview
    };
})();
